export class GetArtifactsParams {
  artifact_ids: Array<string>;
  suppressErrHandler: boolean;
}
